import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { pageTitle } from '../../helper';
// import Cta from '../Cta';
import PageHeading from '../PageHeading';
// import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ModalImage from 'react-modal-image';

const portfolioData = [
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_18.webp',
    srcLg: '/images/img/image_18.webp',
    category: 'Multiplex',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_33.webp',
    srcLg: '/images/img/image_33.webp',
    category: 'Game Zone',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_1.webp',
    srcLg: '/images/img/image_1.webp',
    category: 'Food Court ',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_9.webp',
    srcLg: '/images/img/image_9.webp',
    category: 'Food Court ',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_17.webp',
    srcLg: '/images/img/image_17.webp',
    category: 'Food Court',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_13.webp',
    srcLg: '/images/img/image_13.webp',
    category: 'Multiplex',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_37.webp',
    srcLg: '/images/img/image_37.webp',
    category: 'Game Zone',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_30.webp',
    srcLg: '/images/img/image_30.webp',
    category: 'Game Zone',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_24.webp',
    srcLg: '/images/img/image_24.webp',
    category: 'Game Zone',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_28.webp',
    srcLg: '/images/img/image_28.webp',
    category: 'Game Zone',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_6.webp',
    srcLg: '/images/img/image_6.webp',
    category: 'Multiplex',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_16.webp',
    srcLg: '/images/img/image_16.webp',
    category: 'Multiplex',
    height: 622,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_36.webp',
    srcLg: '/images/img/image_36.webp',
    category: 'Multiplex',
    height: 299,
  },
  {
    title: 'Explore the Multiplex',
    subtitle: 'View Large',
    // href: '/portfolio/portfolio-details',
    src: '/images/img/image_44.webp',
    srcLg: '/images/img/image_44.webp',
    category: 'Multiplex',
    height: 622,
  },
];
const categoryMenu = [
  {
    title: 'Multiplex',
    category: 'Multiplex',
  },
  {
    title: 'Game Zone',
    category: 'Game Zone',
  },
  {
    title: 'Food Court',
    category: 'Food Court',
  },
  
];

export default function PortfolioPage() {
  pageTitle('Portfolio');
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(7);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageHeading
        title="GALLERY"
        bgSrc="images/portfolio_hero_bg.jpeg"
        pageLinkText="Gallery"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title="Spotlight – " subtitle="Friendly and modern, evokes photos & memories" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li
                  className={active === item.category ? 'active' : ''}
                  key={index}
                >
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
      </Div>
      <Spacing lg="90" md="45" />
      <Div className="cs-masonry_4_col">
        {portfolioData.slice(0, itemShow).map((item, index) => (
          <Div
            className={`${active === 'all'
              ? ''
              : !(active === item.category)
                ? 'd-none'
                : ''
              }`}
            key={index}
          >
            <Div
              className="cs-portfolio cs-style1 cs-type2"
              style={{ height: `${item.height}px` }}
            >
              <Div className="cs-lightbox_item">
                <ModalImage
                  small={item.src}
                  large={item.srcLg}
                  alt={item.title}
                />
              </Div>
              <Div className="cs-portfolio_hover" />
              <span className="cs-plus" />
              <Div
                className="cs-portfolio_bg cs-bg"
                style={{ backgroundImage: `url("${item.src}")` }}
              />
              <Div className="cs-portfolio_info">
                <Div className="cs-portfolio_info_bg cs-accent_bg" />
                <h2 className="cs-portfolio_title">{item.title}</h2>
                <Div className="cs-portfolio_subtitle">{item.subtitle}</Div>
              </Div>
            </Div>
          </Div>
        ))}
      </Div>
      <Div className="container">
        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 4)}
              >
                <span>See More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>

      <Spacing lg="145" md="80" />
      {/* Start CTA Section */}
      {/* <Div className="container">
                    <Cta
                      title="Let’s disscuse make <br />something <i>cool</i> together"
                      btnText="Apply For Meeting"
                      btnLink="/contact"
                      bgSrc="/images/cta_bg_3.jpeg"
                    />
                  </Div> */}
      {/* End CTA Section */}
    </>
  );
}
